import { ISlotViewItem } from '../../types/interfaces/Slots/Slots';
import { IBluejackServerGame, IBluejackGetUrl } from '../../types/interfaces/Slots/Bluejack';
import { formatBluejackLink, gamesOrder } from './utils';
import { IConvertGameList, ISlotConverter } from '../../types/converter';
import { CasinoType } from 'modules/Casino/types/configuration';

class Converter implements ISlotConverter {
  convertGameList = ({ data }: IConvertGameList<IBluejackServerGame[]>): ISlotViewItem[] =>
    data
      .map((item: IBluejackServerGame) => ({
        id: item.code.toString(),
        gameId: item.code.toString(),
        description: item.name,
        gameName: item.name,
        provider: 'bluejack',
        routeProvider: 'bluejack',
        imageUrl: item.img,
        type: CasinoType.slots,
        tab: ['slotMachines'],
      }))
      .sort(
        (a, b) =>
          (gamesOrder.indexOf(String(a.gameId)) + 1 || Infinity) -
          (gamesOrder.indexOf(String(b.gameId)) + 1 || Infinity - 1),
      );

  convertGameUrl = ({ data, lang, gameId }: IBluejackGetUrl) => formatBluejackLink(data.token, gameId, lang);
}
export default Converter;
